import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import firebaseConfig from '@/api/firebase-config'

let authReady = null

const ensureFirebaseApp = () => {
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig)
  }

  return firebase.app()
}

export const ensureFirebaseAuth = async () => {
  const app = ensureFirebaseApp()
  const auth = app.auth()

  if (auth.currentUser) {
    return auth.currentUser
  }

  if (!authReady) {
    authReady = auth.signInAnonymously()
      .then(result => result.user || auth.currentUser)
      .catch(error => {
        authReady = null
        console.error('[Firebase] Anonymous sign-in failed, will retry on next request.', error)
        throw error
      })
  }

  return authReady
}

ensureFirebaseAuth().catch(() => {})

export default ensureFirebaseAuth
